import moment from 'moment';

import { AustralianState, YesNoAnswer } from 'scenes/common/types';
import { defaultGovernmentCharges } from 'scenes/common/flows/coverOptions/defaults';
import {
  DriverGender,
  Finance,
  MotorQuoteData,
  VehicleSearchType,
} from 'scenes/motor/types';
import {
  InsuranceOption,
  MotorCoverType,
  MotorInsuranceType,
} from 'scenes/motor/flows/coverOptions/types';

export const defaultVehicleFromSearch = {
  bodyType: '',
  year: '',
  make: '',
  family: '',
  variant: '',
  driveType: '',
  engine: {
    description: '',
    capacity: { value: '', unit: '' },
    cylinders: '',
  },
  transmissionType: '',
  plateNumber: '',
  code: '',
  nvic: '',
  model: '',
  series: '',
  popular: false,
};

export const defaultVehicleManualSelectFields = {
  vehicleMake: '',
  vehicleModel: '',
  vehicleManufactureYear: '',
  vehicleType: '',
  vehicleEngineType: '',
};

export const defaultMotorQuoteDetails: MotorQuoteData = {
  addDriver: YesNoAnswer.Unspecified,
  preselectedCoverType: MotorCoverType.Comprehensive,
  preselectedInsuranceType: MotorInsuranceType.Comprehensive,
  prefilledCampaignId: '',
  prefilledPromoCode: '',
  colesCampaignCode: '',
  firstName: '',
  lastName: '',
  gender: DriverGender.Unspecified,
  dob: '',
  overnightParkingAddress: {
    address: '',
    addressLine1: '',
    addressLine2: '',
    gnaf: '',
    houseNo: '',
    latitude: 0,
    longitude: 0,
    lotNo: '',
    postcode: '',
    state: AustralianState.ACT,
    streetName: '',
    streetPrefix: '',
    streetSuffix: '',
    suburb: '',
    unitNo: '',
  },
  yearsDriving: -1,
  claimsMade: -1,
  payableClaims: -1,
  recentInsurer: '',
  isUsedForBusiness: YesNoAnswer.Unspecified,
  businessType: '',
  isSmallBusiness: YesNoAnswer.Unspecified,
  finance: Finance.Unspecified,
  vehicleFinancier: '',
  coverLevel: '',
  policyStartDate: `${moment().format('YYYY-MM-DD')}`,
  additionalDrivers: [],
  licencePlate: '',
  vehicleSearchType: VehicleSearchType.Unspecified,
  vehicleFromSearch: defaultVehicleFromSearch,
  vehicleManuallyEntered: defaultVehicleFromSearch,
  vehicleManualSelectFields: defaultVehicleManualSelectFields,
  hasFlybuys: YesNoAnswer.Unspecified,
  flybuysNumber: '',
  promoCode: '',
  coverForDriversUnder25: YesNoAnswer.Unspecified,
};

export const defaultInsuranceOption: InsuranceOption = {
  insuranceType: MotorInsuranceType.Unspecified,
  coverType: MotorCoverType.Unspecified,
  premium: {
    price: '',
    firstInstalment: '',
    monthlyInstalment: '',
    annualPrice: '',
    yearlyGovernmentCharges: defaultGovernmentCharges,
    monthlyGovernmentCharges: defaultGovernmentCharges,
  },
};
